import axios from "axios";
import { envVars } from "../utils/env-vars";

const axiosClient = axios.create({
  baseURL: envVars.REACT_APP_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosClient;
